import { DataSourceSort } from 'custom_hooks/data_hooks/data_source/data_source';
import { IssuesDefaultSort } from 'pages/Desk/issues/shared';
import {
    DEFAULT_ISSUE_FILTERS,
    ISSUE_FILTER_VALIDATION_CONSTRAINTS,
} from 'shared/issue_filters_context/StoreUtils';
import { IssueFilters } from 'shared/issue_filters_context/types';
import { createStorageUtils } from 'shared/storage/createStorageUtils';
import { isValidSortArray, isValidTabIndex } from 'shared/storage/validation';
import { ObjectConstraints } from 'utils/object-validation';

export type StoredLocationOverviewState = IssueFilters &
    Readonly<{
        sort: DataSourceSort[];
        alertsAndDraftsTabIndex: number;
    }>;

export const DefaultLocationOverviewState: StoredLocationOverviewState = {
    ...DEFAULT_ISSUE_FILTERS,
    sort: IssuesDefaultSort,
    alertsAndDraftsTabIndex: 0,
};

const LocationOverviewStateConstraints: ObjectConstraints<StoredLocationOverviewState> = {
    ...ISSUE_FILTER_VALIDATION_CONSTRAINTS,
    sort: isValidSortArray,
    alertsAndDraftsTabIndex: isValidTabIndex,
};

const locationOverviewStorage = createStorageUtils<StoredLocationOverviewState>({
    baseKey: 'location-overview.state.storage',
    constraints: LocationOverviewStateConstraints,
    defaults: DefaultLocationOverviewState,
});

export const getLocationOverviewStorageKey = locationOverviewStorage.getStorageKey;
export const loadLocationOverviewState = locationOverviewStorage.load;
export const saveLocationOverviewState = locationOverviewStorage.save;
export const clearLocationOverviewState = locationOverviewStorage.clear;
